var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GmfDatepicker_1;
import { css, html, unsafeCSS } from 'lit';
import i18next from 'i18next';
import { customElement } from 'lit/decorators.js';
import GmfTimeInput from 'gmf/time-input/time-input';
/**
 * Gives you a datepicker (simple or range) based on OGC time.
 * Based on GmfTimeInput.
 * Example:
 * <gmf-datepicker time="myTimeConfig"></gmf-datepicker>
 */
let GmfDatepicker = GmfDatepicker_1 = class GmfDatepicker extends GmfTimeInput {
    /**
     * Lit rendering.
     * @returns the html template for datepicker(s).
     */
    render() {
        if (!this.timeProp) {
            return html ``;
        }
        const startText = this.isTimeRange() ? 'From:' : 'Date:';
        const i18nextOptions = { nsSeparator: '#' };
        const datepickerStart = html `
      <span>${i18next.t(startText, i18nextOptions)}</span>
      <input
        class="datepicker-start"
        type="date"
        .min=${this.timeProp.minValue}
        .max=${this.getDateMax()}
        .value=${this.timeProp.minDefValue ?? this.timeProp.minValue}
        @change="${(e) => this.onDateStartSelected(e)}"
      />
    `;
        let datepickerEnd = null;
        if (this.isTimeRange()) {
            datepickerEnd = html `
        <span>${i18next.t('To:', i18nextOptions)}</span>
        <input
          class="datepicker-end"
          type="date"
          .min=${this.getDateMin()}
          .max=${this.timeProp.maxValue}
          .value=${this.timeProp.maxDefValue ?? this.timeProp.maxValue}
          @change="${(e) => this.onDateEndSelected(e)}"
        />
      `;
        }
        return html ` <style>
        ${unsafeCSS(GmfDatepicker_1.styles)}
      </style>
      <div>
        <span>${datepickerStart}</span>
        ${datepickerEnd ? html `<span>${datepickerEnd}</span>` : html ``}
      </div>`;
    }
    /**
     * On range mode, calculate the min date value with the second date-picker's value.
     * @returns The min selectable date.
     * @private
     */
    getDateMin() {
        if (!this.isTimeRange()) {
            return this.timeProp.minValue;
        }
        const start = this.shadowRoot.querySelector('.datepicker-start');
        return start ? start.value : this.timeProp.minValue;
    }
    /**
     * On range mode, calculate the max date value with the second date-picker's value.
     * @returns The max selectable date.
     * @private
     */
    getDateMax() {
        if (!this.isTimeRange()) {
            return this.timeProp.maxValue;
        }
        const end = this.shadowRoot.querySelector('.datepicker-end');
        return end ? end.value : this.timeProp.maxValue;
    }
};
GmfDatepicker.styles = [
    css `
      input[type='date'] {
        font-size: 80%;
      }
    `,
];
GmfDatepicker = GmfDatepicker_1 = __decorate([
    customElement('gmf-datepicker')
], GmfDatepicker);
export default GmfDatepicker;
//# sourceMappingURL=datepicker.js.map